import { FCWithChildren, useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { nameof } from '../../utils/stringUtils';

const ReportContainerDiv = styled.div<{ num: number; noAnimation?: boolean }>`
  padding: 0.75rem;
  background-color: ${p => p.theme.isInverted ? p.theme.palette.neutralLight : p.theme.palette.neutralLighter};
  border-radius: 0.5rem;
  box-shadow: ${p => p.theme.effects.elevation4};
  overflow-y: hidden;

  @keyframes ReportContainerDiv-appear {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  ${p => !p.noAnimation && css`animation: ReportContainerDiv-appear 0.3s ease-in;`}
  animation-delay: ${p => p.num * 0.15}s;
  animation-fill-mode: both;
`;

const PlaceholderDiv = styled.div`
  height: 32px;
`;

type IProps = {
    num: number;
    noAnimation?: false;
} | {
    num?: number;
    noAnimation: true;
};

const ReportContainer: FCWithChildren<IProps> = ({ children, num, noAnimation }) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(
        () => {
            if (!containerRef.current || !containerRef.current.parentElement)
                return;

            const handleIntersectionChange = (entries: IntersectionObserverEntry[]) => setIsVisible(entries[0].isIntersecting);

            const observer = new IntersectionObserver(handleIntersectionChange, { root: containerRef.current.parentElement, rootMargin: '5px', threshold: 0.01 });
            observer.observe(containerRef.current);

            return () => observer.disconnect();
        },
        [],
    );

    return (
        <ReportContainerDiv ref={containerRef} num={num ?? 0} noAnimation={noAnimation}>
            {isVisible ? children : <PlaceholderDiv />}
        </ReportContainerDiv>
    );
};

ReportContainer.displayName = nameof({ ReportContainer });
export default ReportContainer;